module.exports = __webpack_public_path__ + "img/forgot-password-v2-dark.07077a7a.svg";